import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";

export const ZipTownList = ({ API, zips = [] }) => {
  const [towns, setTowns] = useState([]);
  const key = zips.join(",");

  useEffect(() => {
    if (!key) { setTowns([]); return; }
    let cancelled = false;
    fetch(`${API}/zip-towns?zipcodes=${key}`)
      .then((r) => r.json())
      .then((d) => { if (!cancelled) setTowns(Array.isArray(d) ? d : []); })
      .catch(() => { if (!cancelled) setTowns([]); });
    return () => { cancelled = true; };
  }, [API, key]);

  if (!towns.length) return null;
  return (
    <div className="mt-3" data-testid="zip-town-list">
      <p className="text-slate-400 text-[11px] font-semibold uppercase tracking-wider mb-2">Target areas</p>
      <div className="flex flex-wrap gap-2">
        {towns.map((t) => (
          <span
            key={t.zipcode}
            className="inline-flex items-center gap-1.5 rounded-full bg-violet-500/10 ring-1 ring-violet-400/30 px-3 py-1 text-xs"
            data-testid={`zip-town-${t.zipcode}`}
          >
            <MapPin className="w-3 h-3 text-violet-300" />
            <span className="text-white font-semibold">{t.town}</span>
            <span className="text-slate-400 tabular-nums">{t.zipcode}</span>
          </span>
        ))}
      </div>
    </div>
  );
};
